export const formatCurrency = (inputValue: string): string => {
        let numericValue = inputValue.replace(/\D/g, ""); // Remove tudo que não for número
        let formattedValue = (Number(numericValue) / 100).toLocaleString("pt-BR", {
                style: "currency",
                currency: "BRL",
        });

        return formattedValue.replace("R$", "").trim(); // Remove "R$" para evitar duplicação
};

export const formatCurrencyToFloat = (value: string): number => {
        let valueFormmater = value;
        valueFormmater = valueFormmater.replace(/R\$\s*/g, ''); // Remove todas as ocorrências de 'R$' e espaços após
        valueFormmater = valueFormmater.replace(/\s+/g, ''); // Remove todos os espaços extras
        valueFormmater = valueFormmater.replace(/\./g, ''); // Remove todos os pontos (separadores de milhar)
        valueFormmater = valueFormmater.replace(/,/g, '.'); // Substitui todas as vírgulas por pontos
        return Number(valueFormmater); // Substitui todas as vírgulas por pontos
};